import axios from "axios";
import { JTS_API_BASE_URL } from "../../../constants/Constants";

const ADMIN_QUERY_TYPE = 99999;
const ADMIN_INSERT_ACTION = 1;
const ADMIN_INSERT_QUERY_PARAM = "AdminInsertMoLine";

const getInsertUrl = () =>
  `${JTS_API_BASE_URL}/index.php?query_type=${ADMIN_QUERY_TYPE}&action=${ADMIN_INSERT_ACTION}&query_param=${ADMIN_INSERT_QUERY_PARAM}`;

const normalizePayload = (payload) => {
  const data = {
    po: String(payload?.po || "").trim(),
    mo: String(payload?.mo || "").trim(),
    usuario: String(payload?.usuario || "").trim(),
    team: String(payload?.team || "").trim(),
    tipo: String(payload?.tipo || "").trim(),
    fecha_ini: payload?.fecha_ini,
    fecha_fin: payload?.fecha_fin,
    cantidad_proceso:
      payload?.cantidad_proceso === "" || payload?.cantidad_proceso == null
        ? undefined
        : Number(payload.cantidad_proceso),
  };

  if (payload?.codigo != null && String(payload.codigo).trim() !== "") {
    data.codigo = String(payload.codigo).trim();
  }
  if (payload?.duracion != null && String(payload.duracion).trim() !== "") {
    data.duracion = payload.duracion;
  }
  if (payload?.tipo_tiempo != null && String(payload.tipo_tiempo).trim() !== "") {
    data.tipo_tiempo = String(payload.tipo_tiempo).trim();
  }
  if (payload?.peso != null && String(payload.peso).trim() !== "") {
    data.peso = payload.peso;
  }
  if (
    payload?.cantidad_incidencia != null &&
    String(payload.cantidad_incidencia).trim() !== ""
  ) {
    data.cantidad_incidencia = payload.cantidad_incidencia;
  }

  return data;
};

export const insertAdminMoLine = async (payload) => {
  const url = getInsertUrl();
  const body = normalizePayload(payload);

  try {
    const response = await axios.post(url, body, {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: false,
    });

    let data = response?.data;
    if (typeof data === "string") {
      try {
        data = JSON.parse(data);
      } catch (error) {
        return {
          status: "error",
          message: "La respuesta del servidor no es JSON valido.",
        };
      }
    }

    return data || { status: "error", message: "Respuesta vacia del servidor." };
  } catch (error) {
    console.error("insertAdminMoLine: error", error);
    return {
      status: "error",
      message:
        error?.response?.data?.message ||
        error?.message ||
        "Error de conexion al insertar la linea.",
    };
  }
};
